// This function allow to reference chunks
__webpack_require__.k = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + {"267": "__federation_expose_RxHistory","567": "__federation_expose_RxInput",}[chunkId] + "." + {"267": "79d7f0be","567": "f07bf1d1",}[chunkId] + ".css"
}